import { ProductType } from '@apps/api-interfaces';

// Definicje JSON-LD (schema.org). Organization ma TEN SAM @id co graf na
// zatrzymajlicznik.pl (Astro, BaseLayout) - grafy portalu i porownywarki
// lacza sie w jedna calosc dla crawlerow i LLM-ow.

const ZL = 'https://zatrzymajlicznik.pl';
const COMPARER = `${ZL}/porownywarka`;

export const ORGANIZATION_ID = `${ZL}/#organization`;

export const ORGANIZATION_SCHEMA = {
  '@type': 'Organization',
  '@id': ORGANIZATION_ID,
  name: 'ZatrzymajLicznik.pl',
  url: ZL,
  logo: `${ZL}/logo/mark.png`,
  slogan: 'Niższe rachunki. Większa kontrola. Lepszy biznes.',
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+48732901090',
      contactType: 'customer service',
      availableLanguage: 'pl'
    }
  ]
};

export const WEBSITE_SCHEMA = {
  '@type': 'WebSite',
  '@id': `${ZL}/#website`,
  url: ZL,
  name: 'ZatrzymajLicznik.pl',
  inLanguage: 'pl-PL',
  publisher: { '@id': ORGANIZATION_ID }
};

const PRODUCT_COPY: {
  [key: string]: { name: string; description: string; label: string };
} = {
  prad: {
    name: 'Porównywarka cen prądu dla firm',
    label: 'Porównywarka prądu',
    description:
      'Bezpłatne porównanie ofert sprzedawców energii elektrycznej dla firm. ' +
      'Zmiana sprzedawcy bez przerw w dostawie, oszczędności do 30% rocznie.'
  },
  gaz: {
    name: 'Porównywarka cen gazu dla firm',
    label: 'Porównywarka gazu',
    description:
      'Bezpłatne porównanie ofert sprzedawców gazu ziemnego dla firm. ' +
      'Ten sam gaz, ta sama sieć - niższa cena za paliwo.'
  },
  fotowoltaika: {
    name: 'Porównywarka ofert fotowoltaiki dla firm',
    label: 'Porównywarka fotowoltaiki',
    description:
      'Bezpłatne porównanie ofert sprawdzonych instalatorów fotowoltaiki. ' +
      'Dobór instalacji do zużycia i realny czas zwrotu inwestycji.'
  }
};

export const productServiceSchema = (product: ProductType) => {
  const copy = PRODUCT_COPY[product] || PRODUCT_COPY.prad;
  return {
    '@type': 'Service',
    '@id': `${COMPARER}/${product}#service`,
    name: copy.name,
    description: copy.description,
    serviceType: 'Porównanie cen energii',
    provider: { '@id': ORGANIZATION_ID },
    areaServed: { '@type': 'Country', name: 'Polska' },
    audience: { '@type': 'BusinessAudience', name: 'Firmy i instytucje' },
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'PLN',
      description: 'Bezpłatne porównanie ofert'
    }
  };
};

export const productWebAppSchema = (product: ProductType) => {
  const copy = PRODUCT_COPY[product] || PRODUCT_COPY.prad;
  return {
    '@type': 'WebApplication',
    '@id': `${COMPARER}/${product}#app`,
    name: copy.name,
    url: `${COMPARER}/${product}`,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    inLanguage: 'pl-PL',
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'PLN' },
    provider: { '@id': ORGANIZATION_ID }
  };
};

export const breadcrumbSchema = (items: { name: string; url: string }[]) => ({
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url
  }))
});

export const productBreadcrumbSchema = (product: ProductType) => {
  const copy = PRODUCT_COPY[product] || PRODUCT_COPY.prad;
  return breadcrumbSchema([
    { name: 'ZatrzymajLicznik.pl', url: ZL },
    { name: copy.label, url: `${COMPARER}/${product}` }
  ]);
};

export const articleSchema = (article: {
  title: string;
  description?: string;
  image?: string;
  slug: string;
  product: string;
  publishedAt?: string;
  updatedAt?: string;
}) => ({
  '@type': 'Article',
  headline: (article.title || '').slice(0, 110),
  description: article.description || undefined,
  image: article.image || undefined,
  inLanguage: 'pl-PL',
  datePublished: article.publishedAt || undefined,
  dateModified: article.updatedAt || article.publishedAt || undefined,
  mainEntityOfPage: `${COMPARER}/${article.product}/artykuly/${article.slug}`,
  author: { '@id': ORGANIZATION_ID },
  publisher: { '@id': ORGANIZATION_ID }
});

export const faqSchema = (items: { question: string; answer: string }[]) => ({
  '@type': 'FAQPage',
  inLanguage: 'pl-PL',
  mainEntity: items.map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: { '@type': 'Answer', text: item.answer }
  }))
});
